import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import classNames from 'classnames'

import {
  AgentIngressButton,
  AgentIngressPromptType,
} from '~/components/agent/ingress'
import FeatureToggle from '~/constants/featureToggle'
import { useAgentIngress } from '~/hooks/useAgentIngress'
import { getFeatureToggle } from '~/store/reducers/constants'

import { useRightRailOverlay } from '../context/RightRailOverlayContext'
import AppointmentsSummaryWidget from './appointments/AppointmentsSummaryWidget'
import LabsHistoryWidget from './labs/LabsHistoryWidget'
import PrescriptionsSummaryWidget from './prescriptions/PrescriptionsSummaryWidget'
import ProblemsSummaryWidget from './problems/ProblemsSummaryWidget'
import RhapVitalsWidget from './vitals/RhapVitalsWidget'

import railShellStyles from './PatientMedicalSummaryRail.module.scss'
import styles from './PatientMedicalSummaryRailContent.module.scss'

interface PatientMedicalSummaryRailContentProps {
  clientId: string
  patientId: string
}

export const PatientMedicalSummaryRailContent = ({
  clientId,
  patientId,
}: PatientMedicalSummaryRailContentProps) => {
  const { isOverlayOpen, overlayContent } = useRightRailOverlay()
  const { handleIngress } = useAgentIngress({
    patientId,
    clientId,
  })
  const { t } = useTranslation()
  const isAwoPmrRightRailPhaseTwo = useSelector(
    getFeatureToggle(FeatureToggle.AWO_RIGHT_RAIL_PHASE_2),
  )
  const isAwoChargesR53Layout = useSelector(
    getFeatureToggle(FeatureToggle.AWO_CHARGES_R5_3),
  )

  const summaryWidgets = (
    <>
      <AgentIngressButton
        text={t('Agent:SUMMARIZE_HISTORY')}
        onClick={() => handleIngress(AgentIngressPromptType.MEDICAL_HISTORY)}
      />
      {isAwoPmrRightRailPhaseTwo && (
        <AppointmentsSummaryWidget patientId={patientId} />
      )}
      <RhapVitalsWidget patientId={patientId} />
      <ProblemsSummaryWidget clientId={clientId} patientId={patientId} />
      <PrescriptionsSummaryWidget clientId={clientId} patientId={patientId} />
      <LabsHistoryWidget clientId={clientId} patientId={patientId} />
    </>
  )

  if (!isAwoChargesR53Layout) {
    return (
      <div
        className={classNames(railShellStyles.railContentLegacy, {
          [railShellStyles.overlayOpenLegacy]: isOverlayOpen,
        })}
      >
        {isOverlayOpen && (
          <div className={railShellStyles.overlayContainerLegacy}>
            {overlayContent}
          </div>
        )}
        {summaryWidgets}
      </div>
    )
  }

  return (
    <div className={styles.railViewport}>
      <div
        className={classNames(styles.railScroll, {
          [styles.overlayOpen]: isOverlayOpen,
        })}
      >
        {summaryWidgets}
      </div>
      {isOverlayOpen && (
        <div className={styles.overlayContainer}>{overlayContent}</div>
      )}
    </div>
  )
}
